module.exports = __webpack_public_path__ + "img/服装小票.28036a80.jpg";